import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/Blockchain Blackboard.avif';
import securityImage from '../pictures/Block Security Generation.avif';
import chainImage from '../pictures/Two Chains.avif';
import hardwareImage from '../pictures/Block Structure.avif';

export function HowItWorks() {
  return (
    <MarketingArticle
      title="How Back-Step Blockchain Works"
      kicker="Plain-English overview"
      description="Back-Step Blockchain uses patented hardware-supported security to make trusted records fast enough for real business systems."
      path="/overview"
      heroImage={heroImage}
      heroAlt="Blockchain concept on a blackboard"
      primaryAction={{ to: '/publications', label: 'Read publications' }}
      secondaryAction={{ to: '/contact', label: 'Ask for a briefing' }}
      sections={[
        {
          tag: 'The problem',
          title: 'Traditional blockchains pay a high price for trust.',
          paragraphs: [
            'Many blockchains depend on large public networks, slow consensus, and repeated storage across thousands of systems. That model can be useful, but it is often too costly or slow for business records.',
            'Back-Step Blockchain was designed for customers who need strong evidence without turning every record into a cryptocurrency transaction.',
          ],
        },
        {
          tag: 'The difference',
          title: 'The chain is secured by forward and backward proof.',
          image: securityImage,
          imageAlt: 'Block security generation diagram',
          paragraphs: [
            'Every block is linked so later changes are exposed. The patented back-step method adds a second protection path, making it harder to forge a believable alternative history.',
            'For the customer, that means records can be verified later with confidence and without a slow global mining process.',
          ],
        },
        {
          tag: 'Flexible records',
          title: 'One platform can support many business chains.',
          image: chainImage,
          imageAlt: 'Two chains diagram',
          paragraphs: [
            'Back-Step Blockchain can store small events, documents, images, software, certificates, and references to other chains. Applications can run their own logical chains while sharing a trusted foundation.',
            'This helps partners build products for different industries without redesigning the trust layer each time.',
          ],
        },
        {
          tag: 'Security',
          title: 'Hardware support strengthens the foundation.',
          image: hardwareImage,
          imageAlt: 'Block structure diagram',
          paragraphs: [
            'Generator hardware protects secrets and performs core security functions. Server deployments can add redundancy so records remain available even if one system fails.',
            'The result is a practical trust engine for customer-facing applications and critical internal records.',
          ],
        },
      ]}
    />
  );
}
